module.exports = __webpack_public_path__ + "static/media/goSpotifySelection.6a4f3134.png";